var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkscoreTransit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44397 6.57586L5.1862 2.92287L5.98922 4.04968C6.59809 4.90407 7.58434 5.41161 8.63568 5.41161H9.44651L10.4357 9.3705C10.5766 9.93441 10.9342 10.4205 11.4315 10.7239L14.4698 12.5775C14.5713 12.6394 14.6331 12.7495 14.6331 12.8681V13.9705H10.8208C9.96215 13.9705 9.13497 13.6482 8.50384 13.0679L1.44397 6.57586ZM6.01081 1.72728C5.67626 1.25783 5 1.1976 4.58726 1.6005L5.06542 2.08725L4.58726 1.6005L0.359215 5.72772C-0.129762 6.20504 -0.117973 6.99328 0.385062 7.45585L0.731095 7.08193L0.385062 7.45586L7.57706 14.0694C8.46064 14.8819 9.61869 15.333 10.8208 15.333H14.804C15.4645 15.333 16 14.7992 16 14.1408V12.8681C16 12.2752 15.6907 11.7249 15.1833 11.4154L12.145 9.56172C11.9538 9.44503 11.8162 9.25808 11.762 9.04119L10.6922 4.75941C10.5879 4.34202 10.2118 4.04907 9.78031 4.04907H8.63568C8.02701 4.04907 7.45602 3.75523 7.10352 3.26059L6.01081 1.72728ZM5.15062 13.9705H0.366636V15.333H5.15062V13.9705Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkscoreTransit);
export default __webpack_public_path__ + "static/media/walkscore-transit.07ea4c7b.svg";
export { ForwardRef as ReactComponent };